import { connect } from 'react-redux';

import Test from './test';
import { onLoadTests, selectTest, onSubmitAnswer, onSubmitTest, onRestart, selectResult } from '../../reducers/test.reducers';
import { onLoadCard, onLoadCardSucceeded } from '../../reducers/course.reducers';

const mapStateToProps = state => ({
  isLoading: state.tests.isLoadingQuestions,
  test: state.tests.selectedTest,
  questions: state.tests.questions,
  runStartedAt: state.tests.runStartedAt,
  correctAnswersCount: state.tests.correctAnswersCount,
  completed: state.tests.selectedTest && !!state.tests.selectedTest.endDate,
  tests: state.tests.previewTests,
  card: state.courses.cardForModal,
});

const mapDispatchToProps = dispatch => ({
  loadTest: (test) =>{
    dispatch(selectTest(test))
  },
  loadResult: (test) =>{
    dispatch(selectResult(test))
  },
  onSubmitAnswer: (question, answersTicked) => dispatch(onSubmitAnswer({ question, answersTicked})),
  onSubmitTest: () => dispatch(onSubmitTest()),
  onRestart: () => dispatch(onRestart()),
  onLoadCard: (options)  => dispatch(onLoadCard(options)),
  onCloseLinkedCard: () => dispatch(onLoadCardSucceeded({card: null}))
});

export default connect(mapStateToProps, mapDispatchToProps)(Test);



// WEBPACK FOOTER //
// ./src/app/main/test-all/test.container.js